module.exports = __webpack_public_path__ + "media/images/social-media/linkedin-e1e4883cf545fefddfa9d6a14e9809e5.svg";